import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { defineComponent } from 'vue';
import { DesignColor } from '@/typings/design';


export default /*#__PURE__*/_defineComponent({
  __name: 'BadgeDefault',
  props: {
  backgroundColor: {
    type: String as () => DesignColor,
    default: () => 'warning',
  },
},
  setup(__props) {



defineComponent({ name: 'BadgeDefault' });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["badge rounded-pill px-1", `text-bg-${__props.backgroundColor}`])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})